import {
  distinctUntilChanged,
  debounceTime,
  takeWhile,
  tap,
  switchMap,
  map,
  catchError
} from "rxjs/operators";
import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  OnChanges,
  SimpleChanges
} from "@angular/core";
import { CoreService } from "../../services/coreService";
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Icons, IconCss, UserGroups } from "../../../assets/config/models";
import { Subject } from "rxjs";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { CommonModule } from "@angular/common";

@Component({
    selector: "parking-place-parking-history",
    templateUrl: "./parking-place-parking-history.component.html",
    styleUrls: ["./parking-place-parking-history.component.scss"],
    standalone: true,
    imports: [NgxDatatableModule, FormsModule, ReactiveFormsModule, CommonModule]
})
export class ParkingPlaceParkingHistoryComponent
  implements OnInit, OnDestroy, OnChanges {
  @Input()
  id;
  @Input()
  group;
  groupTypes = UserGroups;
  loading = false;
  sortIcons = Icons;
  sortColumns = [];
  sorts = { prop: "", dir: "" };
  form: UntypedFormGroup;
  page = {
    //The number of elements in the page
    size: 0,
    //The total number of elements
    totalElements: 0,
    //The current page number
    pageNumber: 0
  };
  icons = IconCss;
  iconsCss = {
    pagerLeftArrow: this.icons.left,
    pagerRightArrow: this.icons.right,
    pagerPrevious: this.icons.previous,
    pagerNext: this.icons.next
  };
  isLoading = false;
  rows = [];
  history$ = new Subject<{ offset: number }>();
  formChanges$;

  constructor(public coreService: CoreService, private builder: UntypedFormBuilder) {
    this.form = this.builder.group({
      username: [""],
      plate_number: [""]
    });
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.history$
      .pipe(
        tap(val => {
          console.log(val);
          this.page.pageNumber = val.offset;
          this.isLoading = true;
        }),
        switchMap(val => {
          return this.coreService.GetParkingPlaceHistory(
            {
              offset: this.page.pageNumber * this.page.size,
              limit: this.page.size
            },
            this.form.controls,
            this.sorts,
            this.id
          );
        }),

        catchError(e => {
          this.isLoading = false;
          return this.coreService.handleObservableError(e);
        })
      )
      .subscribe((response: any) => {
        this.rows = response.data;
        this.page.totalElements = response.total_list;
        this.isLoading = false;
      });
    this.setSort();
  }

  resetFilters() {
    this.form.reset();
    this.sorts = { prop: "", dir: "" };
    this.setSort();
  }

  getIcon(prop) {
    return this.sortColumns.find(element => element.prop == prop).icon;
  }

  setSort() {
    this.sortColumns = [];
    for (let key of Object.keys(this.form.value)) {
      this.sortColumns.push({
        prop: key,
        icon: this.sortIcons.none
      });
    }
    this.sortColumns.push({
      prop: "in_time",
      icon: this.sortIcons.none
    });
    this.sortColumns.push({
      prop: "out_time",
      icon: this.sortIcons.none
    });
  }

  onSort(event) {
    console.log("event", event);
    this.sorts = event.sorts[0];
    this.setSort();
    let icon;
    switch (event.sorts[0].dir) {
      case "asc": {
        icon = this.sortIcons.asc;
        break;
      }
      case "desc": {
        icon = this.sortIcons.desc;
        break;
      }
      default: {
        icon = this.sortIcons.none;
        break;
      }
    }
    this.sortColumns.find(
      element => element.prop == event.sorts[0].prop
    ).icon = icon;
    this.history$.next({ offset: 0 });
  }

  async ngOnInit() {
    this.formChanges$ = this.form.valueChanges
      .pipe(
        debounceTime(1000),
        distinctUntilChanged()
      )
      .subscribe(form => {
        this.history$.next({ offset: 0 });
      });
  }

  ngOnDestroy(): void {
    this.history$.unsubscribe();
    this.formChanges$.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.id.currentValue != null) {
      this.history$.next({ offset: 0 });
    }
  }
}
